import { Get, Post, Put, Delete } from '../../api/axiosCoreConfig';

export const postAPatientReport = (data) => Post(`/report/`, data);
// export const getAPatientReport = (reportId, namespace) =>
//     Get(`/report/${reportId}?namespace=${namespace}`);
export const getAPatientReports = (patientId, offset, limit, namespace) =>
    Get(`/report?patient_id=${patientId}&namespace=${namespace}&offset=${offset}&limit=${limit}`);
// export const editAPatientReport = (reportId, data) => Put(`/report/${reportId}`, data);
export const deleteAPatientReport = (reportId, namespace) =>
    Delete(`/report/${reportId}?namespace=${namespace}`);
export const addImageToPatientReport = (reportId, data, config) =>
    Post(`/report/${reportId}/image`, data, config);
export const deleteAPatientReportImage = (reportId, imageId, namespace) =>
    Delete(`/report/${reportId}/image/${imageId}?namespace=${namespace}`);
export const getAllReportType = (namespace) => Get(`/report/type?namespace=${namespace}`);
export const getAllReportLocation = (offset, limit, reportTypeId, namespace) =>
    Get(
        `report/location?report_type_id=${reportTypeId}&namespace=${namespace}&offset=${offset}&limit=${limit}`
    );
export const putAPatientReport = (reportId, data) => Put(`report/${reportId}`, data);
